import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom';
import './StatusPages.css';

interface StatusPageProps {
  code: string;
  title: string;
  message: string;
}

function StatusPage({ code, title, message }: StatusPageProps) {
  return (
    <div className="status-page">
      <p className="status-page__code identifier">{code}</p>
      <h1 className="status-page__title">{title}</h1>
      <p className="status-page__message">{message}</p>
      <Link to="/" className="button button--primary">
        Back to Voleto
      </Link>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <StatusPage
      code="404"
      title="Page not found"
      message="That page doesn't exist, or hasn't been built yet."
    />
  );
}

export function ForbiddenPage() {
  return (
    <StatusPage
      code="403"
      title="Not your portal"
      message="You're signed in, but this area isn't available for your role."
    />
  );
}

/** Router-level error boundary — catches render and loader failures. */
export function RouteErrorPage() {
  const error = useRouteError();

  const code = isRouteErrorResponse(error) ? String(error.status) : '500';
  const message = isRouteErrorResponse(error)
    ? error.statusText || 'Something went wrong handling that route.'
    : error instanceof Error
      ? error.message
      : 'Something went wrong.';

  return <StatusPage code={code} title="Something broke" message={message} />;
}
